module.exports = __webpack_public_path__ + "static/media/content-image-1.89aaaefd.png";